import { SortDirection, type SortField, ViewTypeName } from '@air/api/types';

import { RELEVANCE_SORT_FIELD_NAME } from '~/constants/relevanceSortFieldName';
import { type SearchSortOverride } from '~/store/configViews/types';

const SORT_WITH_ASC_DEFAULT = ['name', 'firstName', 'lastName', 'size', 'ext', 'type'];

export const getDefaultSortDirection = (fieldName: string) =>
  SORT_WITH_ASC_DEFAULT.includes(fieldName) ? SortDirection.asc : SortDirection.desc;

// Enumerated explicitly so a future fourth ViewTypeName doesn't silently inherit a sort menu.
export const isViewSortingMenuSupported = (viewTypeName: ViewTypeName | undefined): boolean =>
  viewTypeName === ViewTypeName.gallery || viewTypeName === ViewTypeName.kanban || viewTypeName === ViewTypeName.table;

export const isRelevanceSortFieldName = (fieldName: string | undefined) => fieldName === RELEVANCE_SORT_FIELD_NAME;

export const isSortFieldWithDirection = (fieldName: string) =>
  fieldName !== 'customSort' && !isRelevanceSortFieldName(fieldName);

type GetAppliedSortFieldParams = {
  currentSortField: SortField | undefined;
  hasSearchParams: boolean;
  searchSortOverride: SearchSortOverride;
};

export const getAppliedSortField = ({
  currentSortField,
  hasSearchParams,
  searchSortOverride,
}: GetAppliedSortFieldParams): SortField | undefined => {
  if (searchSortOverride && hasSearchParams) {
    return { direction: SortDirection.desc, name: searchSortOverride };
  }

  return currentSortField;
};
